export const employeeCountCohorts = ['1-5', '6-20', '21-50', '51-100','101-500','501-1000','1000+'];
export const titleCohorts = ['Founder/CEO', 'Finance/HR Manager', 'Employee'];
